import { Fragment } from "react/jsx-runtime";
import {
	Box,
	CircularProgress,
	Paper,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { TableWrapper } from "./styled";
import { BaseTablePropsType } from "../../types/app.type";
import { BaseButton } from "../button/styled";

export const BaseTable: React.FC<BaseTablePropsType> = ({
	headers,
	rows,
	location,
	handleItemClick,
	isMigrating,
	activeRow,
}) => {
	return (
		<TableWrapper component={Paper}>
			<Table>
				<TableHead>
					<TableRow>
						{headers?.map((header, index) => {
							return <TableCell key={index}>{header}</TableCell>;
						})}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((row, index) => {
						if (location === "all-migrations") {
							const successfulTables =
								row?.tables?.filter(
									(t: Record<string, any>) => t.status === "success"
								) || [];
							const failedTables =
								row?.tables?.filter(
									(t: Record<string, any>) => t.status === "failed"
								) || [];
							const pendingTables =
								row?.tables?.filter(
									(t: Record<string, any>) => t.status === "pending"
								) || [];
							return (
								<TableRow key={index}>
									<TableCell>{row?.institution}</TableCell>
									<TableCell>{row?.status}</TableCell>
									<TableCell>
										<strong>{successfulTables.length}</strong>
										{successfulTables.length > 0 && (
											<div className="table-names">
												{successfulTables
													.map((t: Record<string, any>) => t.tableName)
													.join(", ")}
											</div>
										)}
									</TableCell>
									<TableCell>
										<strong>{failedTables.length}</strong>
										{failedTables.length > 0 && (
											<div className="table-names">
												{failedTables
													.map((t: Record<string, any>) => t.tableName)
													.join(", ")}
											</div>
										)}
									</TableCell>
									<TableCell>
										<strong>{pendingTables.length}</strong>
										{pendingTables.length > 0 && (
											<div className="table-names">
												{pendingTables
													.map((t: Record<string, any>) => t.tableName)
													.join(", ")}
											</div>
										)}
									</TableCell>
								</TableRow>
							);
						}
						return (
							<TableRow key={index}>
								{location === "list-of-institutions" && (
									<Fragment>
										<TableCell>{row?.name}</TableCell>
										<TableCell>{row?.phone}</TableCell>
										<TableCell>{row?.status}</TableCell>
										<TableCell>
											<BaseButton
												variant="contained"
												bgcolor="#791377"
												padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
												fontWeight={800}
												fontSize={13}
												onClick={(e) => handleItemClick?.(e, row.id)}
											>
												<Typography
													variant={"button"}
													fontFamily={"inherit"}
													fontWeight={"inherit"}
													fontSize={"inherit"}
													lineHeight={"inherit"}
													color={"inherit"}
													textTransform={"inherit"}
												>
													Edit
												</Typography>
											</BaseButton>
										</TableCell>
									</Fragment>
								)}
								{location === "all-user-roles" && (
									<Fragment>
										<TableCell>{row.title}</TableCell>
										<TableCell>{row.description}</TableCell>
										<TableCell>
											<Stack direction={"row"} gap={"calc(var(--flex-gap)/4)"}>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) => handleItemClick?.(e, row.id, "edit")}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Edit
													</Typography>
												</BaseButton>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) =>
														handleItemClick?.(e, row.id, "delete")
													}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Delete
													</Typography>
												</BaseButton>
											</Stack>
										</TableCell>
									</Fragment>
								)}
								{location === "all-system-users" && (
									<Fragment>
										<TableCell>{row?.firstName}</TableCell>
										<TableCell>{row?.lastName}</TableCell>
										<TableCell>
											{row?.roles[row?.roles?.length - 1]?.title}
										</TableCell>
										<TableCell>
											<Stack direction={"row"} gap={"calc(var(--flex-gap)/4)"}>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) => handleItemClick?.(e, row.id, "edit")}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Edit
													</Typography>
												</BaseButton>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) =>
														handleItemClick?.(e, row.id, "delete")
													}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Delete
													</Typography>
												</BaseButton>
											</Stack>
										</TableCell>
									</Fragment>
								)}
								{location === "all-sms-alerts" && (
									<Fragment>
										<TableCell>{row?.institution}</TableCell>
										<TableCell>{row?.senderId}</TableCell>
										<TableCell>
											<Stack direction={"row"} gap={"calc(var(--flex-gap)/4)"}>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) => handleItemClick?.(e, row.id, "edit")}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Edit
													</Typography>
												</BaseButton>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) =>
														handleItemClick?.(e, row.id, "delete")
													}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Delete
													</Typography>
												</BaseButton>
											</Stack>
										</TableCell>
									</Fragment>
								)}
								{location === "all-currencies" && (
									<Fragment>
										<TableCell>{row?.country}</TableCell>
										<TableCell>{row?.title}</TableCell>
										<TableCell>{row?.symbol}</TableCell>
										<TableCell>
											<Stack direction={"row"} gap={"calc(var(--flex-gap)/4)"}>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) => handleItemClick?.(e, row.id, "edit")}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Edit
													</Typography>
												</BaseButton>
												<BaseButton
													variant="contained"
													bgcolor="#791377"
													padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
													fontWeight={800}
													fontSize={13}
													onClick={(e) =>
														handleItemClick?.(e, row.id, "delete")
													}
												>
													<Typography
														variant={"button"}
														fontFamily={"inherit"}
														fontWeight={"inherit"}
														fontSize={"inherit"}
														lineHeight={"inherit"}
														color={"inherit"}
														textTransform={"inherit"}
													>
														Delete
													</Typography>
												</BaseButton>
											</Stack>
										</TableCell>
									</Fragment>
								)}
								{location === "all-migration-results" && (
									<Fragment>
										<TableCell>{row?.table}</TableCell>
										<TableCell>
											{" "}
											{row?.status
												? `${String(row.status)
														.charAt(0)
														.toUpperCase()}${String(row.status)
														.slice(1)
														.toLowerCase()}`
												: ""}
										</TableCell>
										<TableCell>
											{row?.status === "error" ? (
												<Box>
													<Typography
														fontFamily={"Inter"}
														fontWeight={"500"}
														fontSize={14}
														lineHeight={"normal"}
														color={"#1B6FFF"}
														whiteSpace={"normal"}
														sx={{ cursor: "pointer" }}
														onClick={(e) =>
															handleItemClick?.(e, row.table, "view-details")
														}
													>
														View Details
													</Typography>
												</Box>
											) : (
												<Box>
													<BaseButton
														variant="contained"
														bgcolor="#791377"
														padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
														fontWeight={800}
														fontSize={13}
														onClick={(e) =>
															handleItemClick?.(e, row.table, "migrate-table")
														}
													>
														{isMigrating && row?.table === activeRow ? (
															<CircularProgress
																color="inherit"
																className="loader"
															/>
														) : (
															<Typography
																variant={"button"}
																fontFamily={"inherit"}
																fontWeight={"inherit"}
																fontSize={"inherit"}
																lineHeight={"inherit"}
																color={"inherit"}
																textTransform={"inherit"}
															>
																Migrate
															</Typography>
														)}
													</BaseButton>
												</Box>
											)}
										</TableCell>
									</Fragment>
								)}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableWrapper>
	);
};
